/**
 * Canonical site URL — single source of truth for the primary domain.
 *
 * Every canonical link, Open Graph URL, structured-data (JSON-LD) URL and
 * sitemap entry MUST be built from this constant. This guarantees that even
 * when the site is served from the preview host or a *.emergentagent.com
 * fallback, search engines still index the primary production domain.
 *
 * Preferred version: non-www + HTTPS.
 */
export const SITE_URL = "https://ecowallet.in";

/** Build a fully-qualified URL for a path on the primary site. */
export const absoluteUrl = (path = "/") => {
  if (!path) return SITE_URL + "/";
  if (/^https?:\/\//i.test(path)) return path;
  return SITE_URL + (path.startsWith("/") ? path : `/${path}`);
};
